export default __webpack_public_path__ + "static/media/btn-arrow.6e2930b8.svg";